<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle navbar-toggle-black"
            @click="toggleNavbar"
            data-toggle="collapse"
            data-target="#navigation-example-2"
          >
            <span class="sr-only">{{ $t('toggle_navigation') }}</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <span class="navbar-brand">{{ ws.getSetting('name') }}</span>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link :to="{name: 'Login'}" class="btn"><i class="fas fa-sign-in-alt"></i> {{ $t('looking_to_login') }}?</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                    <br/><br/>
                  <h4>{{ $t('register_today_start_uploading') }} <i class="fas fa-cloud-upload-alt"></i> </h4>
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-success">
                      <i class="fas fa-thumbs-up"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>{{ $t('great') }}!</h5>{{ $t('almost_on_board') }}
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon">
                      <i class="fas fa-user"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>{{ $t('free_account') }}</h5>{{$t('creating_account_is_free')}}
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-warning">
                      <i class="fas fa-space-shuttle"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>{{ $t('awesome_performances') }}</h5>{{ $t('we_provide_fast_stable_fileservice')}}
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-info">
                      <i class="fas fa-life-ring"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>{{ $t('friendly_support') }}</h5>{{ $t('we_can_help_issues') }}.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-success">
                      <i class="fas fa-handshake"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>{{ $t('companies_welcome') }}!</h5>{{ $t('if_you_have_tuningcompany_welcome') }}.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card card-plain">
                  <div class="content">
                    <form-wizard
                      shape="tab"
                      @on-complete="wizardComplete"
                      error-color="#EB5E28"
                      color="#66615B"
                    >
                      <h4 slot="title"></h4>
                      <tab-content
                        :title="$t('personal_details')"
                        :before-change="validateFirstStep"
                        icon="fas fa-user"
                      >
                        <first-step ref="firstStep"></first-step>
                      </tab-content>

                      <tab-content
                        :title="$t('additional_info')"
                        :before-change="validateSecondStep"
                        icon="fas fa-building"
                      >
                        <second-step ref="secondStep"></second-step>
                      </tab-content>

                      <tab-content
                        :title="$t('finish')"
                        :before-change="validateFinalStep"
                        icon="fas fa-check-circle"
                      >
                        <final-step ref="finalStep"></final-step>
                      </tab-content>

                      <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">
                        <i class="fas fa-arrow-circle-left"></i> {{ $t('back') }}
                      </button>
                      <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">
                        <i class="fas fa-arrow-circle-right"></i> {{ $t('next') }}
                      </button>
                      <button slot="finish" class="btn btn-success btn-fill btn-wd" :disabled="processingRegistration">
                        <i class="fas fa-check-circle"></i> {{ $t('finish') }}
                      </button>
                    </form-wizard>
                  </div>
                  <div class="footer text-center">
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link :to="{name: 'Login'}">{{ $t('looking_to_login') }}?</router-link>
        </li>
        <li>
          <router-link to="/portal">{{ $t('dashboard') }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import FirstStep from "./Register/FirstStep.vue";
import SecondStep from "./Register/SecondStep.vue";
import FinalStep from "./Register/FinalStep.vue";
import swal from "sweetalert2";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
export default {
  components: {
    FormWizard,
    TabContent,
    FirstStep,
    SecondStep,
    FinalStep
  },
  data() {
    return {
      customer: {},
      customerModel: {},
      processingRegistration: false
    };
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    register() {
      this.$validator.validate().then(result => {
        if(this.customerModel.agreeTermsConditions == false) {
          swal("Warning", this.$t('you_need_to_agree'), "warning");
        } else {
          this.processingRegistration = true;
          Webservice.register(this.customerModel).then(resp => {
            if(resp.data == 'success') {
              swal("Success", this.$t("registration_success"), "success");
              this.$router.push({ name: 'Login' });
            } else if(resp.data == 'email_already_exists') {
              this.processingRegistration = false;
              swal("Error", this.$t("email_exists"), "error");
            }
          }).catch(function (error) {
            this.processingRegistration = false;
            swal("Error", this.$t("general_error"), "error");
        })
        }
      });
    },
    validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    validateFinalStep() {
      return this.$refs.finalStep.validate();
    },
    wizardComplete() {
      // we gather models from all steps into one model
      this.customerModel = {
        ...this.$refs.firstStep.model,
        ...this.$refs.secondStep.model,
        ...this.$refs.finalStep.model
      };
      this.register();
      
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  computed: {
    ws: () => {
      return Webservice;
    }
  }
};
</script>
<style>
.wizard-header {
  display: none;
}
.vue-form-wizard .wizard-icon-circle.tab_shape {
  background-color: #9a9a9a !important;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Register.vue